import { AnyEntity, EntityTypesSupportingExport } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import getFieldModelByEntityType from "../fieldModel/getByEntityType";

import downloadCsv from "./downloadCsv";

const downloadEntitiesAsCsv = (
  fileNameWithoutExtension: string,
  entityType: EntityTypesSupportingExport,
  entities: AnyEntity[],
  fieldList?: IField[]
) => {
  const fieldModel = getFieldModelByEntityType(entityType);
  const fields: IField[] = fieldList ?? fieldModel.fields;
  const header = fields.map((field) => field.exportDisplayName);
  const rows = entities.map((entity) =>
    fields.map((field) => field.getFormattedCsvValueFor(entity))
  );
  downloadCsv(fileNameWithoutExtension, [header, ...rows]);
};

export default downloadEntitiesAsCsv;
